export default {
  data() {
    return {
      editinput: '',
      selectbox: ''
    };
  },
  components: {},
  props: {
    field: {
      type: Object,
      default: {}
    }
  },
  mounted() {},
  methods: {}
};